import useMutation from "src/hooks/useMutation";

function useBatchCodeUpdate(id) {
  return useMutation({
    path: `/api/v1/batches/${id}/item-codes`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/batches/${id}`,
      shouldRevalidate: true,
    },
  });
}

export default useBatchCodeUpdate;
